const categoryTag = {
    name_en: '',
    name_de: '',
    tag_type_id: 1,
};

export const formInitialValues = {
    categoryTag,
};
